import {
  DateCheckbox,
  Field,
  RichTextEditor
} from '../../../../react-final-form-wrappers'
import FormRow from '../../FormRow'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-final-form'
import { useFieldValue } from '../../../../hooks/useFieldValue'
import AuthenticationService from '../../../../services/AuthenticationService'
import { client } from '../../../../client/client'
import { useState } from 'react'
import TemplateToolbarButton from '../../../../components/RichTextEditor/TemplateToolbarButton'

const TreatmentPlanSection = () => {
  const { t } = useTranslation('treatmentPlanSection')
  const form = useForm()
  const practiceId = useFieldValue('practice.id')
  const userId = AuthenticationService.getUserId()
  const [replaceText, setReplaceText] = useState<string | null>(null)
  const [replaceKey, setReplaceKey] = useState<number>(0)

  const insertTemplate = async () => {
    const response = await client.getTemplate(userId, practiceId, 'treatmentPlan')
    const text = response?.status === 'success' ? response?.data?.template?.text : ''
    setReplaceText(text || '\u200b')
    setReplaceKey((k) => k + 1)
  }

  return (
    <>
      <FormRow>
        <Field
          name="treatmentPlan"
          label={t('treatmentPlan')}
          component={RichTextEditor}
          replaceMarkdown={replaceText}
          replaceKey={replaceKey}
          toolbarCustomButtons={[
            <TemplateToolbarButton
              key="template"
              onClick={insertTemplate}
              title={t('template', { ns: 'settingsPage' })}
            />
          ]}
        />
      </FormRow>
      <FormRow>
        <Field
          style={{ top: -20, left: 20 }}
          name="treatmentPlanConsentDate"
          label={t('treatmentPlanDate')}
          component={DateCheckbox}
        />
      </FormRow>

    </>
  )
}

export default TreatmentPlanSection
